// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import API_BASE_URL from '../../config/api';
// import { Form, Input, Button, Card, Alert, Space, Typography } from 'antd';
// import { SaveOutlined, CloseOutlined } from '@ant-design/icons';

// const { Title } = Typography;
// const { TextArea } = Input;

// const ContactBunchForm = ({ bunch, onClose, onSubmit }) => {
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     if (bunch) {
//       form.setFieldsValue({
//         name: bunch.name,
//         description: bunch.description || ''
//       });
//     } else {
//       form.resetFields();
//     }
//   }, [bunch, form]);

//   const handleSubmit = async (values) => {
//     setError('');
//     setLoading(true);

//     try {
//       const token = localStorage.getItem('token');
//       const bunchData = {
//         name: values.name,
//         description: values.description
//       };

//       if (bunch) {
//         await axios.put(`${API_BASE_URL}/contact-bunches/${bunch.id}`, bunchData, {
//           headers: {
//             Authorization: token
//           }
//         });
//       } else {
//         await axios.post(`${API_BASE_URL}/contact-bunches`, bunchData, {
//           headers: {
//             Authorization: token
//           }
//         });
//       }

//       onSubmit();
//     } catch (err) {
//       setError(err.response?.data?.message || 'An error occurred');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       {error && (
//         <Alert
//           message="Error"
//           description={error}
//           type="error"
//           showIcon
//           style={{ marginBottom: 16 }}
//         />
//       )}

//       <Form
//         form={form}
//         layout="vertical"
//         onFinish={handleSubmit}
//         initialValues={{
//           name: '',
//           description: ''
//         }}
//       >
//         <Form.Item
//           label="Name"
//           name="name"
//           rules={[
//             { required: true, message: 'Please enter a name for this contact bunch' },
//             { max: 100, message: 'Name must be 100 characters or less' }
//           ]}
//         >
//           <Input placeholder="Enter contact bunch name" />
//         </Form.Item>

//         <Form.Item
//           label="Description"
//           name="description"
//           rules={[
//             { max: 500, message: 'Description must be 500 characters or less' }
//           ]}
//         >
//           <TextArea
//             rows={4}
//             placeholder="Describe this contact bunch (optional)"
//             showCount
//             maxLength={500}
//           />
//         </Form.Item>

//         <Form.Item>
//           <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
//             <Button
//               type="default"
//               // icon={<CloseOutlined />}
//               onClick={onClose}
//               disabled={loading}
//             >
//               Cancel
//             </Button>
//             <Button
//               type="primary"
//               htmlType="submit"
//               icon={<SaveOutlined />}
//               loading={loading}
//             >
//               {loading ? 'Saving...' : (bunch ? 'Update Bunch' : 'Add Bunch')}
//             </Button>
//           </Space>
//         </Form.Item>
//       </Form>
//     </div>
//   );
// };

// export default ContactBunchForm;

import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../config/api";

const ContactBunchFormModal = ({ showForm, setShowForm, bunch, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (bunch) {
      setFormData({
        name: bunch.name || "",
        description: bunch.description || "",
      });
    } else {
      resetForm();
    }
  }, [bunch]);

  const resetForm = () => {
    setFormData({ name: "", description: "" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      const bunchData = {
        name: formData.name,
        description: formData.description,
      };

      if (bunch) {
        await axios.put(
          `${API_BASE_URL}/contact-bunches/${bunch.id}`,
          bunchData,
          { headers: { Authorization: token } }
        );
      } else {
        await axios.post(`${API_BASE_URL}/contact-bunches`, bunchData, {
          headers: { Authorization: token },
        });
      }

      resetForm();
      setShowForm(false);
      onSubmit();
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    resetForm();
    setShowForm(false);
  };

  return (
    <div
      className={`modal fade ${showForm ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">
              {bunch ? "Edit Contact Bunch" : "Add Contact Bunch"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCancel}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body">
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              {/* Name */}
              <div className="mb-3">
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter contact bunch name"
                  maxLength={100}
                  required
                />
                <div className="form-text">Max 100 characters</div>
              </div>

              {/* Description */}
              <div className="mb-3">
                <label htmlFor="description" className="form-label">
                  Description
                </label>
                <textarea
                  className="form-control"
                  id="description"
                  name="description"
                  rows="4"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Describe this contact bunch (optional)"
                  maxLength={500}
                />
                <div className="form-text">Max 500 characters</div>
              </div>
            </form>
          </div>

          {/* Footer */}
          <div className="modal-footer d-flex justify-content-end gap-3 p-3">
            <button
              type="button"
              className="btn bg-danger-subtle text-danger px-4"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Saving..." : bunch ? "Update Bunch" : "Add Bunch"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactBunchFormModal;
